import React, { PureComponent } from "react";
import { Button } from "@zendeskgarden/react-buttons";
import { showNewRoute } from "utils/navigation";
import t from "@zendesk/client-i18n-tools";
import Bell from "./bell.svg";

import styles from "./BlankState.css";

export default class BlankState extends PureComponent {
  showNewRoute = () => showNewRoute();

  render() {
    return (
      <div className={styles.blankState} data-test-id="blank-state">
        <h1>{t("knowledge-verification.articleVerifications")}</h1>
        <section className={styles.description}>
          <Bell className={styles.bell} />
          <h2>{t("knowledge-verification.blankState.title")}</h2>
          <p>
            {t.format("knowledge-verification.blankState.description", {
              newline: () => <br key="newline" />,
            })}
          </p>
          <p>
            <a
              href={t("knowledge-verification.blankState.link")}
              target="_blank"
            >
              {t("knowledge-verification.blankState.learnMore")}
            </a>
          </p>
          <Button
            data-test-id="add-verification-rule"
            onClick={this.showNewRoute}
            primary
            size="small"
          >
            {t("knowledge-verification.addVerificationRule")}
          </Button>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexRoute/BlankState.js